import { render } from "./RecommendationReasons.vue?vue&type=template&id=79290d44&scoped=true"
import script from "./RecommendationReasons.vue?vue&type=script&lang=js"
export * from "./RecommendationReasons.vue?vue&type=script&lang=js"

import "./RecommendationReasons.vue?vue&type=style&index=0&id=79290d44&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79290d44"]])

export default __exports__